import 'rxjs/add/operator/map';
import 'rxjs/add/operator/find';
import { Component } from '@angular/core';
import { Globals } from '../../services/globals';
import { NoticeController } from '../../services/notice.controller';
import { AuthenticationService } from '../../services/authentication.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { SessionStorageService } from '../../services/session-storage.service';
import { AlarmService } from '../../services/alarm.service';
import { Router } from '@angular/router';

@Component({
  templateUrl: './setting.html',
  styleUrls: ['./setting.scss'],
})

export class SettingPage {
  /**
   * 아이디
   */
  private id: string;

  /**
   * Local storage
   */
  private $local: LocalStorageService = new LocalStorageService();

  /**
   * Session storage
   */
  private $session: SessionStorageService = new SessionStorageService();

  /**
   * 자동 로그인 여부
   */
  autoLogin: boolean;

  /**
   * 현재 선택되어 있는 아동
   */
  chooseChild: any;

  /**
   * 전체 아동 리스트
   */
  childrenList: any;

  /**
   * 공지사항 정보.
   */
  notice: NoticeController;

  /**
   * 설정할 수 있는 알람 시간
   */
  alarmList: any[] = [];

  /**
   * 알람끄기 여부
   */
  alarmToggle: boolean = false;

  /**
   * @constructor
   */
  constructor(
      private $alarmService: AlarmService,
      private $g: Globals,
      private $authService: AuthenticationService,
      private $router: Router,

      notice: NoticeController) {

    this.notice = notice;

    // 아동 리스트 가져오기, 선택된 아동의 num 저장
    this.childrenList = $g.children;
    this.chooseChild = $g.child.num;

    // 자동 로그인 설정
    this.autoLogin = !!this.$local.getAuthorizationToken();

    // 알람목록 출력
    this.$getAlarms();
  }

  /**
   * 자동 로그인 설정, 해제
   */
  changeAutoLogin() {
    // 자동 로그인 설정시 세션스토리지에 있는 인증토큰을 로컬스토리지로 옮긴다.
    this.autoLogin ?
      this.$local.setAuthorizationToken(
          this.$session.getAuthorizationToken()) :
      this.$local.removeAuthorizationToken();
  }

  /**
   * 로그아웃
   */
  logout() {
    this.$authService.logout(this.id).subscribe(
        () => {
          // 아이디 저장 여부가 없다면 저장된 아이디 제거
          if (!this.$local.getRememberUserId()) {
            this.$local.removeUserId();
          }
          // 선택 아동 제거
          this.$local.removeChildNum();
          // 자동 로그인 해제
          this.$local.removeAuthorizationToken();
          // 탭 인덱스 제거
          this.$local.removeTabIndex();
          // 인증 토큰 제거
          this.$session.removeAuthorizationToken();
          // 로그인 페이지로 이동
          this.$router.navigate(['']);
        },
        err => console.log('Logout error', err));
  }

  /**
   * 비밀번호 변경 페이지로 이동
   */
  changePwd() {
    this.$router.navigate(['/change-pwd']);
  }

  /**
   * 알람 시간 목록
   */
  private async $getAlarms() {
    // 설정 할 수 있는 알람 시간 목록
    const mAlarms = await this.$alarmService.getMiscellaneousAlarms();
    // 사용자가 설정한 알람 목록
    const alarms = await this.$alarmService.getAlarms();
    // 알람 설정 여부를 포함한 알람 목록
    this.alarmList = mAlarms.concat().map((m) => {
      m['active'] = alarms.find(a => a.minute === m.minute);
      return m;
    });
    // 전체 알람 토글
    this.alarmToggle = this.alarmList.find(a => a.active);
  }

  /**
   * 사용자가 설정한 알람 초기화 (전체알람 OFF)
   */
  clearAlarms() {
    // 알람 초기화
    this.$alarmService.clearAlarms().subscribe();
    // 알람 목록 리로드
    this.alarmList.forEach(a => a.active = false);
    this.alarmToggle = this.alarmList.find(a => a.active);
  }

  /**
   * 알람 설정시 알람 업데이트
   * @param alarm 알람 정보
   */
  changeAlarm(alarm) {
    alarm.active ?
      this.$alarmService.registerAlarm(alarm.minute).subscribe() :
      this.$alarmService.deregisterAlarm(alarm.minute).subscribe();
    this.alarmToggle = !!this.alarmList.find(a => a.active);
  }

  /**
   * 아동 클릭시 아동 정보 변경
   */
  changeChild(childNum: any) {
    // 자동 로그인을 위해 식별번호 저장
    this.$local.setChildNum(childNum.toString());
    this.$g.setChildByNum(parseInt(childNum, 10));
    this.chooseChild = childNum;
  }

  /**
   * 공지사항으로 이동
   */
  goNotice() {
    this.$router.navigate(['/notice']);
  }
}
